import { useDeletePhoneLine } from "./api/deletePhoneLine";
import { Button } from "reactstrap";


const DeletePhoneLine = ({handleCloseModal, phoneLineId}: DeletePhoneLineProps)  => {
  const deletePhoneLineMutation = useDeletePhoneLine( { phoneLineId });

  const handleSubmit = async (): Promise<void> => {
    deletePhoneLineMutation.mutateAsync({ 
      phoneLineId: phoneLineId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την τηλεφωνική γραμμή;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeletePhoneLineProps{
  phoneLineId: number;
  handleCloseModal: () => void;
}

export default DeletePhoneLine;